import React, {Component} from 'react';
import server from '../server'
import ClinicEmployees from '../panels/ClinicEmployees';
import EmailInput from '../inputs/EmailInput';
import CpfInput from '../inputs/CpfInput';
import TelephoneInput from '../inputs/TelephoneInput';

class AddEmployer extends Component{
    state = {

    }

    onChange = (event) =>{
        this.setState({[event.target.id]: event.target.value});
    }

    validateSecretary = () =>{
        let failed = false;

        if(this.state.name == null || this.state.name == ""){
            this.setState({name_error: true})
            failed = true;
        }
  
        if(this.state.cpf == null || this.state.cpf.indexOf("_") != -1){
            this.setState({cpf_error: true})
            failed = true;
        }
  
        if(this.state.email == null || this.state.email.split("@")[0] == ""){
            this.setState({email_error: true})
            failed = true;
        }

        if(!failed){
            this.registerSecretary();
        }
    }

    registerSecretary = () => {
        let data = this.state;
        let clinicId = JSON.parse(localStorage.getItem("clinic")).id;

        data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'');
        data["telephone"] = data["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'');
        data["rank"] = "secretary";

        server.post("clinics/" + clinicId + "/employees", data, (data) =>{
            if(data.id){
                this.props.alert("Secretária criada com sucesso!", "Logo ela estará no sistema!", "success");
                this.props.hide();
            }else{
                this.props.alert("Erro ao criar secretária", "Tente novamente mais tarde...", "error");
            }
        });
    }

    validateDoctor = () =>{
        let failed = false;
        
        if(this.state.name == null || this.state.name == ""){
            this.setState({name_error: true})
            failed = true;
        }
  
        if(this.state.cpf == null || this.state.cpf.indexOf("_") != -1){
            this.setState({cpf_error: true})
            failed = true;
        }

        if(this.state.crm == null || this.state.crm == ""){
            this.setState({crm_error: true})
            failed = true;
        }

        if(this.state.specialty == null || this.state.specialty == ""){
            this.setState({specialty_error: true})
            failed = true;
        }
  
        if(this.state.email == null || this.state.email.split("@")[0] == ""){
            this.setState({email_error: true})
            failed = true;
        }

        if(!failed){
            this.registerDoctor()
        }
    }

    registerDoctor = () => {
        let data = this.state;
        let clinicId = JSON.parse(localStorage.getItem("clinic")).id;

        data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'');
        data["telephone"] = data["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'');
        data["rank"] = "doctor";

        server.post("clinics/" + clinicId + "/employees", data, (data) =>{
            if(data.id){
                this.props.alert("Médico criado com sucesso!", "Logo ele estará no sistema!", "success");
                this.props.hide();
            }else{
                this.props.alert("Erro ao criar médico", "Tente novamente mais tarde...", "error");
            }
        });
    }

    render(){
        return(
            <div class={"app-modal2 bgc-white mobile-scroll " + (this.props.open == true ? "active" : "")}>
                <div class="w-100p clinic-data ">
                    <div class="w-100p peers ai-c jc-sb b-0 content-header">
                        <h2 class="m-0">{this.props.modalType == 1 ? "Médico" : "Secretária"}</h2>
                        <button onClick={this.props.hide} type="button" class="modal-toogle2 btn btn-clear pX-5 pY-0 pos-a t-10 r-0 bdrs-2 cur-p c-client-secondary">
                            <i class="material-icons">close</i>
                        </button>

                        <div class="clearfix"></div>
                    </div>
                    <div class="scrollable">
                        <div class="w-100p jc-c ai-c">
                            <div class="mB-30 mT-30 clic form-row">
                                <div class="col-md-12 m-0 peers jc-c">
                                    <div class="col-md-6 p-0 m-0">
                                        <div class="form-group col-md-12 ">
                                            <label for="inputName">Nome</label>
                                            <input id="name" onChange={this.onChange} value={this.state.name} style={this.state.name_error == true? {borderColor:"red"} : {}} class="form-control" name="inputName" placeholder="Nome" required="" type="text"/>
                                        </div>
                                        {this.props.modalType == 1 ?
                                        <div>
                                            <div class="form-group col-md-6">
                                                <label for="inputEspecialidade">Especialidade</label>
                                                <input id="specialty" onChange={this.onChange} value={this.state.specialty} style={this.state.specialty_error == true? {borderColor:"red"} : {}} class="form-control" name="inputEspecialidade" placeholder="Separe multiplas especialidades com espaço" required="" type="text"/>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="inputCRM">CRM</label>
                                                <input id="crm" onChange={this.onChange} value={this.state.crm} style={this.state.crm_error == true? {borderColor:"red"} : {}} class="form-control" name="inputCRM" placeholder="Nome" required="" type="number"/>
                                            </div>
                                        </div>
                                        :<div></div>}
                                        <div class="form-group col-md-12">
                                            <label for="inputEmail">E-mail</label>
                                            <EmailInput id="email" onChange={this.onChange} value={this.state.email} style={this.state.email_error == true? {borderColor:"red"} : {}} class="form-control" name="inputEmail" placeholder="E-mail" required="" type="text"/>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputCPF">CPF</label>
                                            <CpfInput id="cpf" onChange={this.onChange} value={this.state.cpf} style={this.state.cpf_error == true? {borderColor:"red"} : {}} class="form-control" disabled="" name="inputCPF" placeholder="CPF" required=""/>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputPhone">Telefone</label>
                                            <TelephoneInput id="telephone" onChange={this.onChange} value={this.state.telephone} style={this.state.telephone_error == true? {borderColor:"red"} : {}} class="form-control" name="inputPhone" placeholder="Telefone" required="" type="text"/>
                                        </div>

                                        <div class="form-group col-md-6">

                                        </div>
                                        <div onClick={this.props.modalType == 0 ? this.validateSecretary : this.validateDoctor} class="col-md-12 ta-c">
                                            <button type="button" class="btn btn-default">Salvar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class ClinicEdit extends Component{
    constructor(props){
        super(props);
        this.state = {s_active: false, d_active: false, employeeModal: false, key: 0,employees: 0,refresh:false};
    }

    componentWillMount = () => {
        const clinic = JSON.parse(localStorage.getItem('clinic'))
        let totalAppointments = 0;
        let newState = {}

        for(let key in clinic){
          newState["c_"+key] = clinic[key]
        }

        /*clinic.patients.forEach(p =>{
            p.appointments.forEach(a =>{
                if(a.clinic_id == clinic.id) totalAppointments += 1;
            })
        })*/

        newState["totalAppointments"] = totalAppointments;

        this.setState(newState);
    }

    refresh = () =>{
        this.setState({refresh:true});
    }

    updateState = (event) =>{
      this.setState({[event.target.id]:event.target.value})
    }

    register = () =>{
        let keys = Object.keys(this.state);

        let clinic = JSON.parse(localStorage.getItem('clinic'))

        keys.forEach(element => {
            if(element.indexOf("c_") != -1){
                clinic[element.replace("c_","")] = this.state[element];
            }
        });

        // Adjusting data
        if(typeof(clinic["cep"]) === "string"){
            clinic["cep"] = clinic["cep"].replace(/\-/g,'')
        }
        if(typeof(clinic["telephone"]) === "string"){
            clinic["telephone"] = clinic["telephone"].replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'')
        }

        // Saving new info to localStorage
        localStorage.setItem("clinic",JSON.stringify(clinic))

        fetch(server.address + "/clinics/" + clinic.id,{
            method:"PUT",
            headers:{
                'Accept': 'application/json',
                'Content-Type':'application/json'
            },
            body: JSON.stringify(clinic)
        }).then(response => {
            if(response.status == 200){
                this.props.alert("Clinica alterada com sucesso!");
            }
        })
    }

    render(){
        let clinic_types = ["Ortopedia","Geriatria","Neurologia","Otorrinolaringologia","Cardiologia","Pneumologia"]
        return(
            <div key={this.state.key} class="col2-app">
                <div class="col2-app__side-nav peers bdR bgc-white mobile-scroll no-scroll">
                    <div class="w-100p clinic-data ">
                        <div class="peers w-100p ai-c jc-sb content-header">
                            <div class="p-10">
                                <h5 class="m-0 c-client-secondary">Clínica</h5>
                                <h4 class="m-0">{this.state.c_name}</h4>
                            </div>
                        </div>
                        <div class="w-100p pX-10 ta-c pos-r">
                            <button type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0 pos-a t-20 r-2  bdrs-2 cur-p c-client-secondary">
                                <i class="material-icons">close</i>
                            </button>
                            <h3 class="ta-c mB-0">{clinic_types[this.state.c_specialty_id]}</h3>
                            <span class="fsz-md c-client-secondary">{this.state.email}</span>
                            <hr class="small bdc-client-default mY-10"/>
                            <div class="fsz-xs mT-10 c-client-default">Telefone principal</div>
                            <h4 class="m-0">

                                <i class="fa fa-mobile-phone mR-5 c-client-secondary fsz-md"></i>{this.state.c_telephone}</h4>
                            <hr class="mY-10"/>
                        </div>

                        <div class="scrollable">
                            <div class="w-100p pX-10">
                                <div class="fsz-xs c-client-default">Telefone responsável</div>
                                <h4 class="m-0">{this.state.c_telephone}</h4>

                                <div class="fsz-xs mT-10 c-client-default">Endereço</div>
                                <p class="m-0">{this.state.c_street + " " + this.state.c_number}</p>

                                <div class="fsz-xs mT-10 c-client-default">Bairro</div>
                                <p class="m-0">{this.state.c_neighbourhood + " - " + this.state.c_state}</p>

                                <div class="fsz-xs mT-10 c-client-default">Complemento</div>
                                <p class="m-0">{this.state.c_complement}</p>
                                <hr class="mY-10"/>
                            </div>


                            {/*<div class="p-10 peers ai-c jc-sb  w-100p">
                                <div class="w-50p p-10 mB-20 bdR ai-c ta-c">
                                    <i class="fa fa-user fsz-xl c-client-default"></i>
                                    <h3 class="m-0">{this.state.c_patients.length}</h3>
                                    <div class="fsz-xs c-client-secondary">Pacientes Vinculados</div>

                                </div>
                                <div class="w-50p p-10 mB-20 ai-c ta-c">
                                    <i class="fa fa-user-md fsz-xl c-client-default"></i>
                                    <h3 class="m-0">{this.state.totalAppointments}</h3>
                                    <div class="fsz-xs c-client-secondary">Atendimentos realizados</div>
                                </div>
                            </div>*/}
                        </div>

                        <div class="p-0 bdT jc-c w-100p flex-footer">
                            <button class="modal-toogle btn btn-default btn-block h-100p bdrs-0" type="button">Editar clínica</button>
                        </div>
                        <div class="app-modal bgc-white mobile-scroll">
                            <div class="w-100p clinic-data ">
                                <div class="w-100p peers ai-c jc-sb content-header">
                                    <h4 class="m-0">Editando Clínica</h4>
                                    <button type="button" class="modal-toogle btn btn-clear pX-5 pY-0 pos-a t-20 r-0 bdrs-2 cur-p c-client-secondary">
                                        <i class="material-icons">close</i>
                                    </button>
                                </div>
                                <div class="scrollable">

                                    <div class="mB-30 mT-30 clic form-row clinic-edit-form">
                                        <div class="form-group col-md-12">
                                            <label for="inputName">Nome</label>
                                            <input id="c_name" value={this.state.c_name} onChange={this.updateState} class="form-control" name="inputName" placeholder="Nome da clínica" required="" type="text"/>
                                        </div>

                                        <div class="form-group col-md-12">
                                            <label for="inputType">Especialização</label>
                                            <select id="c_specialty_id" onChange={this.updateState} value={this.state.c_specialty_id} class="form-control" name="inputType">
                                                <option value="0">Ortopedia</option>
                                                <option value="1">Geriatria</option>
                                                <option value="2">Neurologia</option>
                                                <option value="3">Otorrinolaringologia</option>
                                                <option value="4">Cardiologia</option>
                                                <option value="5">Pneumologia</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputPhone">Telefone</label>
                                            <input id="c_telephone" value={this.state.c_telephone} onChange={this.updateState} class="form-control" name="inputPhone" placeholder="Telefone" required="" type="text"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputStreet">Endereço</label>
                                            <input id="c_street" value={this.state.c_street} onChange={this.updateState} class="form-control" name="inputStreet" placeholder="Endereço" required="" type="text"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputNumber">Número</label>
                                            <input id="c_number" value={this.state.c_number} onChange={this.updateState} class="form-control" name="inputNumber" placeholder="Numero" required="" type="text"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputNeighborhood">Bairro</label>
                                            <input id="c_neighbourhood" value={this.state.c_neighbourhood} onChange={this.updateState} class="form-control" name="inputNeighborhood" placeholder="Bairro" required="" type="text"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputState">Estado</label>
                                            <input id="c_state" value={this.state.c_state} onChange={this.updateState} class="form-control" name="inputState" placeholder="Estado" maxlength="2" required="" type="text"/>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputComplement">Comnplemento</label>
                                            <input id="c_complement" value={this.state.c_complement} onChange={this.updateState} class="form-control" name="inputComplement" placeholder="Comnplemento" required="" type="text"/>
                                        </div>


                                        <div class="clearfix"></div>
                                    </div>
                                </div>

                                <div class="p-0 bdT jc-c w-100p flex-footer">                         
                                    <button class="btn btn-success btn-block h-100p bdrs-0" onClick={this.register} type="button">Salvar alteração</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col2-app__wrapper">
                    <div class="col2-list h-100p">
                        <div class="peers w-100p ai-c jc-sb content-header">
                            <div class="content-header__left">
                                <div class="content-header__title">
                                    <h3 class="m-0">
                                        Colaboradores <span class="c-client-default fsz-sm"> ( {this.state.employees} )</span>
                                    </h3>
                                </div>
                            </div>
                            <div class="btn-group gap-10 jc-c" role="group">
                                <button onClick={()=> this.setState({employeeModal: true, modalType:0})} class="modal-toogle3 btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-5 cur-p c-client-default" type="button">
                                    <i class="fa fa-plus-circle fsz-md"></i>
                                    Secertária
                                </button>
                                <button onClick={()=> this.setState({employeeModal: true, modalType:1})} class="modal-toogle2 btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default" type="button">
                                    <i class="fa fa-plus-circle fsz-md"></i>
                                    Médico
                                </button>
                            </div>
                        </div>

                        <div class="scrollable h-100p">
                            <div class="content-data peers  ai-c jc-c">
                                <ClinicEmployees shouldRefresh={this.state.refresh} refreshed={() => this.setState({refresh:false})} updateEmployees={(emp) => {this.setState({employees:emp})}}/>
                            </div>
                            <AddEmployer alert={this.props.alert} modalType={this.state.modalType} open={this.state.employeeModal} hide={() => this.setState({employeeModal:false}, this.refresh)}/>
                        </div>
                    </div>
                <div class="bcg-overlay open-details"></div>
            </div>
        </div>
        )
    }
}

export default ClinicEdit



// WEBPACK FOOTER //
// ./src/pages/ClinicEdit.js